// Footer.jsx
import React from "react";
import './Footer.css';
import { FaInstagram, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      {/* Fila superior: 3 columnas */}
      <div className="footer-top">
        <div className="footer-div footer-div-logo">
          <img
            src="/images/logo-vertical.png"
            alt="Juani Pavlovsky Fotografías"
            className="logo-img"
          />
          <p className="prof-text">Fotógrafo Profesional</p>
        </div>

        <div className="footer-div footer-legal">
          <p><Link to="/Legal/CopyRight">© 2025 Juani Pavlovsky</Link></p>
          <p><Link to="/Legal/CopyRight">Todos los derechos reservados</Link></p>
          <p><Link to="/Legal/CopyRight">Términos y Condiciones</Link></p>
        </div>

        <div className="footer-div">
          <h3>Contacto</h3>
          <p><FaMapMarkerAlt /> Buenos Aires, Argentina</p>
          <p>
            Email:{" "}
            <a href="mailto:juanipavlovsky@hotmail.com" className="footer-link">
              juanipavlovsky@hotmail.com
            </a>
          </p>
          <p>
            Teléfono:{" "}
            <a href="tel:+5491160035550" className="footer-link">
              +54 9 11 6003-5550
            </a>
          </p>

          <div className="footer-social-row">
            <a
              href="https://www.instagram.com/juanipavlovskyph?igsh=MW4wcngwc2FnODczbQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="footer-icon-link-instagram"
              aria-label="Instagram de Juani Pavlovsky"
            >
              <FaInstagram size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Franja inferior: full width, texto centrado */}
      <div className="footer-bottom">
        <p>
          Desarrollado por{" "}
          <a
            href="https://keoni-studio.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
           <strong>Keoni Studio</strong>
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
